/*-----------------------------------------------------------------
- General translations
-----------------------------------------------------------------*/

export default {
    layout: {
        title      : 'Site Site Başlığı',
        separator  : '::',
        description: 'Quark :: tarafından güçlü Quarkino',
    },

    404: {
        title       : 'Sayfa bulunamadı.',
        back_to_home: 'Eve gitmek',
    },

    schedule_demo            : 'Demo Planla',
    request_demo             : 'Demo İste',
    schedule_demo_modal_title: 'Beklentilerinizin Ötesinde İnşa Edin',

    header: {
        log_in     : 'giriş',
        client_area: 'Müşteri Alanı',
        schedule   : 'Demo Planla',
    },

    footer: {
        find_us_on              : 'Bizi bulun',
        newsletter_section_title: 'Bülten',
        newsletter_button       : 'Abone',
        placeholder             : 'E-posta adresiniz',
        success_msg             : 'E-postanız başarıyla gönderildi.',
        error_msg               : 'Bir sorun oluştu, lütfen tekrar deneyin.',
    },
};
